<template>
  <div class="popup_detail_wrap">
    <div class="popup_detail">
      <page-header class="not_main"></page-header>
      <div class="popup_detail_content">
        <div class="popup_detail_content_box">
          <popup-detail-component :popupKey="popupKey"></popup-detail-component>
        </div>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import PopupDetailComponent from "@/components/popup/PopupDetailComponent";

export default {
  name: "PopupDetail",
  mixins: [],
  components: {PopupDetailComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      popupKey: ''
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getBoardKey();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getBoardKey() {
      this.popupKey = this.$route.params.p_idx
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>